const MINUTES_IN_DAY = 60 * 24;
export const AVAILABILITY_INTERVAL = 15; // 15m intervals for availability
export const DAY_INTERVALS_COUNT = MINUTES_IN_DAY / AVAILABILITY_INTERVAL;